import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('[AXIOS] Response error intercepted:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      hasResponse: !!error.response
    })
    
    // Redirect to login for both 401 (Unauthorized) and 403 (Forbidden) when token is invalid
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.log(`[AXIOS] ${error.response.status} detected - clearing auth and redirecting to login`)
      // Clear all auth-related data
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth-storage')
      // Redirect to login page
      window.location.href = '/login'
    }
    
    // Format error message
    const message = error.response?.data?.error || error.message || 'An error occurred'
    return Promise.reject(new Error(message))
  }
)

export default api